var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "16px",
    viewBox: "0 0 7 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "89B86852-D28E-4D69-8A07-6EBBAD331FCC-6815-00001F3AAA88D235") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Visuals",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ops---details-page",
    transform: "translate(-1023.000000, -306.000000)",
    fill: "#DE7426",
    fillRule: "nonzero",
    stroke: "#DE7426",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Popup",
    transform: "translate(190.000000, 162.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI-/-Process",
    transform: "translate(641.551724, 138.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Process"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(179.288037, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(1.590264, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-lineart-/--alert",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Alert-/-Warning-/-Color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-lineart-/--am-icon-alert2",
    transform: "translate(5.500000, 0.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.497,10.7595 L2.4765,10.7595 C0.906,10.626 0.29,3.5 0.106,0.4395 L0.0765,0.1195 L4.924,0.1195 L4.906,0.4335 C4.7135,3.4915 4.097,10.62 2.5355,10.7535 L2.497,10.7535 L2.497,10.7595 Z M0.719,0.712 C1.057,5.749 1.8595,9.998 2.497,10.158 C3.146,9.998 3.949,5.749 4.275,0.712 L0.7195,0.712 L0.719,0.712 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.497,14.8805 C1.6265,14.8805 0.9205,14.175 0.9205,13.304 C0.9205,12.433 1.626,11.7275 2.497,11.7275 C3.3675,11.7275 4.0735,12.433 4.0735,13.304 C4.072,14.174 3.367,14.8785 2.4975,14.8805 L2.497,14.8805 Z M2.497,12.2645 C1.9245,12.2645 1.46,12.729 1.46,13.3015 C1.46,13.874 1.9245,14.3385 2.497,14.3385 C3.0695,14.3385 3.534,13.874 3.534,13.3015 C3.5325,12.7295 3.069,12.266 2.497,12.2645 Z",
    id: "Shape"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningOrange);
export default __webpack_public_path__ + "static/media/warning-orange.ccb085d1a5ebe6af7dda50f905fc81b1.svg";
export { ForwardRef as ReactComponent };